export default "__VITE_ASSET__82799cda__"